import styles from './RateCard.module.scss';
import {
	EquipmentModifierPanel,
	TailgateLiftModifierPanel,
	HandUnloadModifierPanel,
	SplitTrailerModifierPanel,
	WeekendAndHolidaysModifierPanel,
	TrailerTypeModifierPanel,
	// TimeframeModifierPanel,
	AdditionalStopsModifierPanel,
	DGModifierPanel,
	OtherModifierPanel,
	AdminBookingFeesPanel,
	TimeSlotModifierPanel
} from '../RC_Modifiers';
import { DEFAULT_RATE_CARD_RANGES, SettingType } from '@types';

type TProps = {
	settingType: SettingType;
	type: keyof typeof DEFAULT_RATE_CARD_RANGES;
	isDisabled?: boolean;
}

export const RateCardModifiers = ({ settingType, type, isDisabled = false }: TProps) => {
	return (
		<div className={styles.expanders}>
			<EquipmentModifierPanel type={type} isDisabled={isDisabled} />
			<TailgateLiftModifierPanel type={type} isDisabled={isDisabled} />
			<HandUnloadModifierPanel type={type} isDisabled={isDisabled} />
			<SplitTrailerModifierPanel type={type} isDisabled={isDisabled} />
			<DGModifierPanel type={type} isDisabled={isDisabled} />
			{/* <TimeframeModifierPanel type={type} isDisabled={isDisabled} /> */}
			<AdditionalStopsModifierPanel stopType={'PICKUP'} type={type} isDisabled={isDisabled} />
			<AdditionalStopsModifierPanel stopType={'DROPOFF'} type={type} isDisabled={isDisabled} />
			<WeekendAndHolidaysModifierPanel type={type} isDisabled={isDisabled} />
			<TrailerTypeModifierPanel type={type} isDisabled={isDisabled} />
			{
				settingType !== 'Carrier' && <AdminBookingFeesPanel type={type} isDisabled={isDisabled} />
			}
			<TimeSlotModifierPanel type={type} isDisabled={isDisabled} />
			<OtherModifierPanel type={type} isDisabled={isDisabled} />
		</div>
	);
}
